import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { UserProvider } from "@auth0/nextjs-auth0";
import { QueryClient, QueryClientProvider } from "react-query";
import { Analytics } from "@vercel/analytics/react";
import "tailwindcss/tailwind.css";
import "public/css/global.css";
import "@components/TextEditor/TextEditor.css";
import "@components/JobPosts/JobPostsSearchAndResults/JobPostsSearchForm/NavLinks.css";
import { useRouter } from "next/router";
import { gtagView } from "@services/googleAnalytics";
import { AnalyticsEvent } from "@utils/redis/analytics/AnalyticsEvent";
import { mixpanelEvent } from "@services/mixpanel";
const queryClient = new QueryClient({
    // Note: disable refetching on window focus - https://react-query.tanstack.com/guides/window-focus-refetching#disabling-globally
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});
export default function App(param) {
    let { Component , pageProps  } = param;
    // Google Analytics
    const router = useRouter();
    useEffect(()=>{
        const handleRouteChange = (url)=>{
            gtagView(url);
            mixpanelEvent({
                name: AnalyticsEvent.PAGE_VIEW,
                payload: {
                    path: url.pathname
                }
            });
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return ()=>{
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    return /*#__PURE__*/ _jsx(UserProvider, {
        children: /*#__PURE__*/ _jsxs(QueryClientProvider, {
            client: queryClient,
            children: [
                /*#__PURE__*/ _jsx(Component, {
                    ...pageProps
                }),
                /*#__PURE__*/ _jsx(Analytics, {})
            ]
        })
    });
}
